document.createElement( "picture" );
picturefill();

function getURLParameter(name) {
    return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.search) || [null, ''])[1].replace(/\+/g, '%20')) || null;
}


/*
 * jQuery BBQ: Back Button & Query Library - v1.3pre - 8/26/2010
 * http://benalman.com/projects/jquery-bbq-plugin/
 * 
 * Copyright (c) 2010 "Cowboy" Ben Alman
 * Dual licensed under the MIT and GPL licenses.
 * http://benalman.com/about/license/
 */
(function($,r){var h,n=Array.prototype.slice,t=decodeURIComponent,a=$.param,j,c,m,y,b=$.bbq=$.bbq||{},s,x,k,e=$.event.special,d="hashchange",B="querystring",F="fragment",z="elemUrlAttr",l="href",w="src",p=/^.*\?|#.*$/g,u,H,g,i,C,E={};function G(I){return typeof I==="string"}function D(J){var I=n.call(arguments,1);return function(){return J.apply(this,I.concat(n.call(arguments)))}}function o(I){return I.replace(H,"$2")}function q(I){return I.replace(/(?:^[^?#]*\?([^#]*).*$)?.*/,"$1")}function f(K,P,I,L,J){var R,O,N,Q,M;if(L!==h){N=I.match(K?H:/^([^#?]*)\??([^#]*)(#?.*)/);M=N[3]||"";if(J===2&&G(L)){O=L.replace(K?u:p,"")}else{Q=m(N[2]);L=G(L)?m[K?F:B](L):L;O=J===2?L:J===1?$.extend({},L,Q):$.extend({},Q,L);O=j(O);if(K){O=O.replace(g,t)}}R=N[1]+(K?C:O||!N[1]?"?":"")+O+M}else{R=P(I!==h?I:location.href)}return R}a[B]=D(f,0,q);a[F]=c=D(f,1,o);a.sorted=j=function(J,K){var I=[],L={};$.each(a(J,K).split("&"),function(P,M){var O=M.replace(/(?:%5B|=).*$/,""),N=L[O];if(!N){N=L[O]=[];I.push(O)}N.push(M)});return $.map(I.sort(),function(M){return L[M]}).join("&")};c.noEscape=function(J){J=J||"";var I=$.map(J.split(""),encodeURIComponent);g=new RegExp(I.join("|"),"g")};c.noEscape(",/");c.ajaxCrawlable=function(I){if(I!==h){if(I){u=/^.*(?:#!|#)/;H=/^([^#]*)(?:#!|#)?(.*)$/;C="#!"}else{u=/^.*#/;H=/^([^#]*)#?(.*)$/;C="#"}i=!!I}return i};c.ajaxCrawlable(0);$.deparam=m=function(L,I){var K={},J={"true":!0,"false":!1,"null":null};$.each(L.replace(/\+/g," ").split("&"),function(O,T){var N=T.split("="),S=t(N[0]),M,R=K,P=0,U=S.split("]["),Q=U.length-1;if(/\[/.test(U[0])&&/\]$/.test(U[Q])){U[Q]=U[Q].replace(/\]$/,"");U=U.shift().split("[").concat(U);Q=U.length-1}else{Q=0}if(N.length===2){M=t(N[1]);if(I){M=M&&!isNaN(M)?+M:M==="undefined"?h:J[M]!==h?J[M]:M}if(Q){for(;P<=Q;P++){S=U[P]===""?R.length:U[P];R=R[S]=P<Q?R[S]||(U[P+1]&&isNaN(U[P+1])?{}:[]):M}}else{if($.isArray(K[S])){K[S].push(M)}else{if(K[S]!==h){K[S]=[K[S],M]}else{K[S]=M}}}}else{if(S){K[S]=I?h:""}}});return K};function A(K,I,J){if(I===h||typeof I==="boolean"){J=I;I=a[K?F:B]()}else{I=G(I)?I.replace(K?u:p,""):I}return m(I,J)}m[B]=D(A,0);m[F]=y=D(A,1);$[z]||($[z]=function(I){return $.extend(E,I)})({a:l,base:l,iframe:w,img:w,input:w,form:"action",link:l,script:w});k=$[z];function v(L,J,K,I){if(!G(K)&&typeof K!=="object"){I=K;K=J;J=h}return this.each(function(){var O=$(this),M=J||k()[(this.nodeName||"").toLowerCase()]||"",N=M&&O.attr(M)||"";O.attr(M,a[L](N,K,I))})}$.fn[B]=D(v,B);$.fn[F]=D(v,F);b.pushState=s=function(L,I){if(G(L)&&/^#/.test(L)&&I===h){I=2}var K=L!==h,J=c(location.href,K?L:{},K?I:2);location.href=J};b.getState=x=function(I,J){return I===h||typeof I==="boolean"?y(I):y(J)[I]};b.removeState=function(I){var J={};if(I!==h){J=x();$.each($.isArray(I)?I:arguments,function(L,K){delete J[K]})}s(J,2)};e[d]=$.extend(e[d],{add:function(I){var K;function J(M){var L=M[F]=c();M.getState=function(N,O){return N===h||typeof N==="boolean"?m(L,N):m(L,O)[N]};K.apply(this,arguments)}if($.isFunction(I)){K=I;return J}else{K=I.handler;I.handler=J}}})})(jQuery,this);
/*
 * jQuery hashchange event - v1.3 - 7/21/2010
 * http://benalman.com/projects/jquery-hashchange-plugin/
 * 
 * Copyright (c) 2010 "Cowboy" Ben Alman
 * Dual licensed under the MIT and GPL licenses.
 * http://benalman.com/about/license/
 */
(function($,e,b){var c="hashchange",h=document,f,g=$.event.special,i=h.documentMode,d="on"+c in e&&(i===b||i>7);function a(j){j=j||location.href;return"#"+j.replace(/^[^#]*#?(.*)$/,"$1")}$.fn[c]=function(j){return j?this.bind(c,j):this.trigger(c)};$.fn[c].delay=50;g[c]=$.extend(g[c],{setup:function(){if(d){return false}$(f.start)},teardown:function(){if(d){return false}$(f.stop)}});f=(function(){var j={},p,m=a(),k=function(q){return q},l=k,o=k;j.start=function(){p||n()};j.stop=function(){p&&clearTimeout(p);p=b};function n(){var r=a(),q=o(m);if(r!==m){l(m=r,q);$(e).trigger(c)}else{if(q!==m){location.href=location.href.replace(/#.*/,"")+q}}p=setTimeout(n,$.fn[c].delay)}$.browser.msie&&!d&&(function(){var q,r;j.start=function(){if(!q){r=$.fn[c].src;r=r&&r+a();q=$('<iframe tabindex="-1" title="empty"/>').hide().one("load",function(){r||l(a());n()}).attr("src",r||"javascript:0").insertAfter("body")[0].contentWindow;h.onpropertychange=function(){try{if(event.propertyName==="title"){q.document.title=h.title}}catch(s){}}}};j.stop=k;o=function(){return a(q.location.href)};l=function(v,s){var u=q.document,t=$.fn[c].domain;if(v!==s){u.title=h.title;u.open();t&&u.write('<script>document.domain="'+t+'"<\/script>');u.close();q.location.hash=v}}})();return j})()})(jQuery,this);



// Isotope - sort by category
$.fn.isotpeConfig = function(){

    var $container = $('.sortableContainer');
    $container.isotope({
        itemSelector : '.sortableItem',
        layoutMode: 'fitRows'
    });

    var $optionSets = $('#navSorting .option-set'),
        $optionLinks = $optionSets.find('a');

    $optionLinks.click(function(){
        parseUrl();
        var $this = $(this);
        /* don't proceed if already selected */
        if ($this.hasClass('selected')){
            return false;
        }

        var $optionSet = $this.parents('.option-set');
            $optionSet.find('.selected').removeClass('selected');
            $this.addClass('selected');

        /* make option object dynamically, i.e. { filter: '.my-filter-class' } */
        var options = {},
        key = $optionSet.attr('data-option-key'),
        value = $this.attr('data-option-value');
        
        

        /* parse 'false' as false boolean */
        value = value === 'false' ? false : value;
        options[ key ] = value;

        if ( key === 'layoutMode' && typeof window.changeLayoutMode === 'function' ) {
            /* changes in layout modes need extra logic */
            window.changeLayoutMode( $this, options );
        } else {
            /* otherwise, apply new options */
            $container.isotope( options );
        }
        return false;
    });
    
    
    $(window).bind( 'hashchange', function( event ){
        // get options object from hash
        var hashOptions = $.deparam.fragment();
        // apply options from hash
        $container.isotope( hashOptions );
    }).trigger('hashchange');
      
    function parseUrl() {
        // get href attr, remove leading #
        var href = $(this).attr('href').replace( /^#/, '' ),
        // convert href into object
        // i.e. 'filter=.inner-transition' -> { filter: '.inner-transition' }
        option = $.deparam( href, true );
        // set hash, triggers hashchange on window
        $.bbq.pushState( option );
        return false;
    }
};

$(window).load(function() {
    // Init Isotope config
    if(window.load_isotpe){
        $.fn.isotpeConfig();
    }
    
    // Equal height cols
    var max_height = 0;
    $('.equalHeight').each(function(){
        if($(this).height() > max_height){
            max_height = $(this).height();
        }
    });
    $('.equalHeight').height(max_height);
});

(function($){
    // Behavior of home slider while playing videos
    $.fn.sliderVideoBehavoir = function(){
        // store slide in var
        var slider = $(".royalSlider").data('royalSlider');

        // hide overlay if a video slide is active
        slider.ev.on('rsAfterSlideChange', function(event) {
            // triggers after slide change
            if ($('.rsActiveSlide').children('.video').length){
                $('#overlay').fadeOut();
                $('.rsPlayBtn').delay(250).fadeIn();
            } else {
                $('#overlay').fadeIn();
                $('.rsPlayBtn').hide();
            }
        });

        // animate markup for video mode
        slider.ev.on('rsVideoPlay', function() {
            if($(window).width() > 768) {
                $('.rsThumbs').animate({bottom: -119});
                $('#overviewWrapper').animate({paddingTop: 150, paddingBottom: 80});
                $('#overviewWrapper .container-fluid').animate({top: 0});
            }
        });

        // re-animate markup for image mode
        slider.ev.on('rsVideoStop', function() {
            if($(window).width() > 768) {
                $('.rsThumbs').animate({bottom: 122});
                $('#overviewWrapper').animate({paddingTop: 50, paddingBottom: 50});
                $('#overviewWrapper .container-fluid').animate({top: -82});
            }
        });
    }; 
    
    /**
     * Dropdown Portable Devices fix
     */   
    $('.dropdownMenu').click(function(){
        $(this).toggleClass('open');
    });


    (function($) {
        /**
         *
         * RoyalSlider double resolution module
         * @version 1.0:
         *
         */
        $.extend($.rsProto, {
            _initExtendedSlider: function() {
                var self = this;

                self.ev.on('rsAfterParseNode', function(e, content, obj) {
                    var image = content.find('.rsImg');
                    var thumbTextOverlay = image.data('thumbTextOverlay');

                    if(thumbTextOverlay !== undefined && thumbTextOverlay != '') {
                        obj.thumbnail = '<span class="thumb_overlay">'+thumbTextOverlay+'</span>'+obj.thumbnail;
                    } else if(obj.thumbnail !== undefined && obj.thumbnail.indexOf("data-rstmb") !=-1) {
                        var replaced_thumbnail_html = obj.thumbnail;


                        // Replace Thumbnail Image
                        var thumb_image = replaced_thumbnail_html.match(/data-rstmb="([^">]+)/);
                        if (thumb_image !== undefined && thumb_image[1] !== undefined) {
                            replaced_thumbnail_html = replaced_thumbnail_html.replace(/(src=")(.*?)(")/, '$1' + thumb_image[1] + '$3');
                        }

                        // Add Text Overlay
                        var overlay_text = replaced_thumbnail_html.match(/data-thumb-text-overlay="([^"]*)"/);
                        if(overlay_text !== undefined && overlay_text[1] !== undefined) {
                            replaced_thumbnail_html = '<span class="thumb_overlay">'+overlay_text[1]+'</span>'+replaced_thumbnail_html;
                        }

                        obj.thumbnail = replaced_thumbnail_html;

                    }

                });

            },

        });
        $.rsModules.extendedSlider = $.rsProto._initExtendedSlider;
    })(jQuery);

    
    // Royal Slider Config
    $.fn.loadRoyalSlider = function(){
        if(window.load_royal_slider){
            // Toggle thumb and overlay visability
            $('#sliderWrapper a.toggle').click(function(){
                var element = $(this);
                var overlay = element.parent().find('.overlay');
                var icon = element.find('i');
                icon.toggleClass('fa-eye-slash fa-eye');
                if(overlay.is(':visible')) {
                    overlay.hide();
                    $('.rsNav').hide();
                } else {
                    overlay.show();
                     $('.rsNav').show();
                }
                
                return false;
            });

            var slider_element = $('.royalSlider');




            slider_element.royalSlider({
                controlNavigation: (window.royal_slider_thumbs === true) ? 'thumbnails' : 'none',
                fitInViewport: true,
                navigateByClick: (window.royal_slider_counter === 1) ? false : true,
                imageAlignCenter: false,
                imageScaleMode: 'none',
                slidesSpacing: 0,
                keyboardNavEnabled: (window.royal_slider_counter === 1) ? false : true,
                arrowsNav: false,
                sliderDrag: (window.royal_slider_counter === 1) ? false : true,
                loop: true,
                loopRewind: true,
                autoHeight: true,
                autoPlay: {
                    enabled: (window.royal_slider_counter === 1) ? false : true,
                    pauseOnHover: true,
                    delay: 12000
                },
                transitionType: 'move',
                video: {
                    autoHideBlocks: true
                },
                usePreloader: false,
                thumbs: {
                    spacing: 10,
                    firstMargin: false,
                    arrows: false,
                    autoCenter: false
                },
                addActiveClass: true,
                allowCSS3: false
            });

            var slider = slider_element.data('royalSlider');

            /*
            slider.ev.on('rsBeforeParseNode', function(e, content, obj) {
                //console.log(content);

                 $('.rsNavItem').each(function(index){
                 var slider = $(this).closest('.royalSlider');
                 var current_slide = slider.find('.rsSlide:eq('+index+')');
                 var image = $(current_slide.find('.rsImg'));
                 var thumbTextOverlay = image.data('thumbTextOverlay');
                 console.log(current_slide.attr('src'));
                 console.log(thumbTextOverlay);
                 });


            });


            slider.ev.on('rsAfterContentSet', function(e, slideObject) {
                var current_slide = $(slideObject);
                var thumbTextOverlay = $(slideObject).find('.rsImg').data('thumbTextOverlay');
                var slider = $(slideObject).closest('.royalSlider');
                var thumbnail_container = slider.find('.rsNavItem:eq('+$(slideObject).index()+')');


                //console.log(current_slide);
            });
             */





            slider.ev.on('rsBeforeMove', function(event, type, userAction ) {
                $('.rsNav').show();
            });

            // Init video handling of slider
            $.fn.sliderVideoBehavoir();




        }
    };
    



    $.fn.loadSiteMenu = function(){
        
        // Close function
        function close(){
            var element = $('#siteSwitch');
            element.removeClass('active');
        }
        
        function toggle(e){
            var element = $('.siteSwitch');
            
            // Prevent from close on mouseenter 
            if(e.type == 'mouseenter' && element.hasClass('active')) { return false; }
            
            // Toggle
            element.toggleClass('active');
        }
        
        // Close/Open on hover/click icon
        $('.siteSwitch > a').on('click',function(e) {
            e.preventDefault();
            toggle(e);
        });

        if($(window).width() >= 760) {
            $('.siteSwitch > a').on('mouseenter', function (e) {
                e.preventDefault();
                toggle(e);
            });

            $('.siteSwitch').on('mouseleave', function (e) {
                e.preventDefault();
                toggle(e);
            });
        }
    
        // Close on outside click
        $('html:not(siteSwitch)').unbind('click').click(function(){
            close();
        });
    
        // don't close on inside click
        $('.siteSwitch').unbind('click').click(function(e){
            e.stopPropagation();
        });
        
    };
})(jQuery);

// on doc ready
jQuery(document).ready(function($) {
    videojs.options.flash.swf = "https://www.360gradzahn.de/wp-content/themes/default/assets/flash/video-js.swf";
    
    // Simple preloader
    $(window).load(function(){
        $("#preloader").delay(350).fadeOut(300);
    });

    $('.html5fileupload.demo_multi').html5fileupload({
    	onAfterStartSuccess: function(response) {
    		console.log(this.element);
    	}
    });

    if(window.supersizedSetting) { 
        $.supersized.themeVars = {
            // Internal Variables
            progress_delay		:	false,				// Delay after resize before resuming slideshow
            thumb_page 			: 	true,				// Thumbnail page
            thumb_interval 		: 	true,				// Thumbnail interval
            image_path			:	'https://www.360gradzahn.de/wp-content/themes/default/assets/img/supersized/',				// Default image path

            // General Elements							
            play_button			:	'#pauseplay',		// Play/Pause button
            next_slide			:	'#nextslide',		// Next slide button
            prev_slide			:	'#prevslide',		// Prev slide button
            next_thumb			:	'#nextthumb',		// Next slide thumb button
            prev_thumb			:	'#prevthumb',		// Prev slide thumb button
            
            slide_caption		:	'#slidecaption',	// Slide caption
            slide_current		:	'.slidenumber',		// Current slide number
            slide_total			:	'.totalslides',		// Total Slides
            slide_list			:	'#slide-list',		// Slide jump list							
            
            thumb_tray			:	'#thumb-tray',		// Thumbnail tray
            thumb_list			:	'#thumb-list',		// Thumbnail list
            thumb_forward		:	'#thumb-forward',	// Cycles forward through thumbnail list
            thumb_back			:	'#thumb-back',		// Cycles backwards through thumbnail list
            tray_arrow			:	'#tray-arrow',		// Thumbnail tray button arrow
            tray_button			:	'#tray-button',		// Thumbnail tray button
            
            progress_bar		:	'#progress-bar'		// Progress bar
        								
        };		
        
        $.supersized({
			slideshow               :   supersizedSetting[1],		//Slideshow on/off
            autoplay				:	supersizedSetting[2],			// Slideshow starts playing automatically
	    	start_slide             :   1,			// Start slide (0 is random)
	    	stop_loop				:	0,			// Pauses slideshow on last slide
	    	random					: 	0,			// Randomize slide order (Ignores start slide)
	    	slide_interval          :   6000,		// Length between transitions
	    	transition              :   6, 			// 0-None, 1-Fade, 2-Slide Top, 3-Slide Right, 4-Slide Bottom, 5-Slide Left, 6-Carousel Right, 7-Carousel Left
	    	transition_speed		:	1000,		// Speed of transition
	    	new_window				:	1,			// Image links open in new window/tab
	    	pause_hover             :   0,			// Pause slideshow on hover
	    	keyboard_nav            :   1,			// Keyboard navigation on/off
	    	performance				:	1,			// 0-Normal, 1-Hybrid speed/quality, 2-Optimizes image quality, 3-Optimizes transition speed // (Only works for Firefox/IE, not Webkit)
	    	image_protect			:	1,			// Disables image dragging and right click with Javascript
	    											   
	    	// Size & Position						   
	    	min_width		        :   0,			// Min width allowed (in pixels)
	    	min_height		        :   0,			// Min height allowed (in pixels)
	    	vertical_center         :   1,			// Vertically center background
	    	horizontal_center       :   1,			// Horizontally center background
	    	fit_always				:	0,			// Image will never exceed browser width or height (Ignores min. dimensions)
	    	fit_portrait         	:   1,			// Portrait images will not exceed browser height
	    	fit_landscape			:   0,			// Landscape images will not exceed browser width
	    											   
	    	// Components							
	    	navigation              :   1,			//Slideshow controls on/off
			thumbnail_navigation    :   0,			//Thumbnail navigation
			slide_counter           :   1,			//Display slide numbers
	    	slide_links				:	'blank',	// Individual links for each slide (Options: false, 'number', 'name', 'blank')
	    	thumb_links				:	1,			// Individual thumb links for each slide
	    	slides 					:  	supersizedSetting[3],
													
			// Theme Options			   
			progress_bar			:	1,			// Timer for each slide							
			mouse_scrub				:	1
			
		}); 
		$('#tray-button').click();
    }


    // Load RoyalSlider
    $.fn.loadRoyalSlider();
    $.fn.loadSiteMenu();

    // Load Fancybox
    $('a.fancybox, div.gallery-size-thumbnail a').fancybox({
        openEffect: 'elastic',
        closeEffect: 'elastic',
        margin: 40,
        padding: 0,
        helpers : {
            overlay : {
                css : {
                    'background' : 'rgba(0,0,0,.85)'
                }
            }
        }
    });

    if($('.modal_overlay').length){
        // alert dialog
        alertify.set({ labels: {
            ok     : "Schließen"
        } });
        alertify.alert($('.modal_overlay').html());
    }

    /*
    // Load Newsticker (jnewsticker-jquery-news-ticker)
    $('#tickerWrapper').newsticker({
        showControls: false,
        slideSpeed : 0,
        scrollSpeed : 20,
        autoStart : true,
        style : 'scroll',
        tickerTitle: "Newsticker: "
    });
    */
    
    // If is gallery page set height for contentWrapper
    function setGalleryPageHeight() {
        if( $('body').hasClass('page-template-template-gallery-php') ) {
            var docHeight       = $(window).height(),
                toplineHeight   = $('#topLine').outerHeight(),
                headerHeight    = $('#headerWrapper').outerHeight();
            
            $('#contentWrapper').css('height', docHeight - toplineHeight - headerHeight);
        }
    }
    setGalleryPageHeight();

    // Resize trigger (Notice: this trigger should only be called once!)
    $(window).resize(function() {
        // Load Responsive handling
        $.fn.responsiveDesign();
        setGalleryPageHeight();
    });

    // Load Responsive handling
    $.fn.responsiveDesign();




    // center submenu
    function centerSubmenu(){
        var parentLi = $('#navMain ul > li');
        parentLi.hover(function(){
            var liWidth = $(this).outerWidth();
            var ulWidth = $(this).find('.sub-menu').outerWidth();
            $(this).find('.sub-menu').css('left', -(ulWidth-liWidth)/2);
        });
    }
    //centerSubmenu();


    $('.accordion').each(function(){
        var _accordion = $(this);
        var _list = _accordion.find('>li');
        var _contents = _list.find('.accordion--content');
        _contents.hide();

        $('.accordion--title').click(function(e) {
            e.preventDefault();
        });

        $('.accordion--title').click(function() {
            var toggle_conteint = $(this).next('.accordion--content');

            if(toggle_conteint.is(':visible')) { return toggle_conteint.slideToggle(); }

            _contents.slideUp();
            toggle_conteint.slideToggle();
            return true;
        });
    });

    // Tabbed Content
    if($('.tabbedContent').length){
        
        var tabContainers = $('.tabbedContent > div');
        tabContainers.hide().filter(':first').show();

        $('.tabsNav a').click(function () {
                tabContainers.hide();
                tabContainers.filter(this.hash).show();
                $('.tabsNav li').removeClass('selected');
                $(this).parent().addClass('selected');
                return false;
        }).filter(':first').click();
    }
    
    setTimeout(function() {
        var logo = $('#logo img');
        var original_logo_width = 'auto';
        var original_logo_height = $('#logo img').height();
        

        $(window).scroll(function () {
            if($(window).width() <= 980) {
                return false;
            }
            
            var megamenu = $('#navMain .megamenu_overlay');
            var headerElement = $('#headerWrapper');
            var navMainLi = $('#navMain > ul > li');
        
            if ($(window).scrollTop() >= 45) {
                var factor = 0.6;
                
                if(!headerElement.hasClass('fixed')) {
                    $('#contentWrapper').addClass('fixed-header');
                    headerElement.addClass('fixed');
                    logo.css({
                        paddingTop: 5,
                        width: original_logo_width * factor,
                        height: original_logo_height * factor
                    });
                    
                    navMainLi.animate({
                        paddingTop: 12,
                        paddingbottom: 0
                    }, 200);
                    
                     megamenu.animate({
                        top: 54
                    }, 200);
                }
            } else {
                if(headerElement.hasClass('fixed')) {
                    var factor = 1;
                    $('#contentWrapper').removeClass('fixed-header');
                    headerElement.removeClass('fixed');
                    
                    logo.css({
                        paddingTop: '',
                        width: '',
                        height: ''
                    });
                    
                    navMainLi.animate({
                        paddingTop: 35,
                        paddingbottom: 15
                    }, 200);
                    
                    megamenu.animate({
                        top: 74
                    }, 200);
                }
                
            }
        });
    }, 30);

    $('.testimonialSlider').each(function(){
        console.log($(this).find('.testimonialEntry').length);
        if($(this).find('.testimonialEntry').length <= 1) { return false; }
        $(this).royalSlider({
            controlNavigation: 'bullets',
            navigateByClick: true,
            slidesSpacing: 0,
            keyboardNavEnabled: false,
            arrowsNav: false,
            sliderDrag: true,
            loop: true,
            loopRewind: true,
            autoHeight: true,
            autoPlay: {
                enabled: true,
                pauseOnHover: true,
                delay: 6000
            },
            transitionType: 'move',
            addActiveClass: true,
            allowCSS3: false
        });
    });

	$('.twentytwenty-container').twentytwenty({
        before_label: 'Vorher',
        after_label: 'Nachher'
    });
});

// YouTube modal.
function open_youtube_modal(id, title) {
	$('#modal-youtube').modal('show');

	var titleContainer = document.getElementById('youtube-title');
	titleContainer.innerHTML = title;

	var iframe = document.createElement('iframe');

	iframe.setAttribute('frameborder', '0');
	iframe.setAttribute('allowfullscreen', '');
	iframe.setAttribute('src', 'https://www.youtube-nocookie.com/embed/' + id + '?rel=0&showinfo=0&autoplay=1');

	var videoContainer = document.getElementById('youtube-video');
	videoContainer.innerHTML = '';
	videoContainer.appendChild(iframe);
}

// Stop/remove YouTube video when modal is closed.
$('#modal-youtube').on('hidden.bs.modal', function (e) {
	var $this = $(this);
	var $frame = $this.find('iframe');
	$frame.attr("src", '');
});

// Mega Menu
$('.menu-item.megamenu > a').on('click', function () {
    var w = $(window).width();
    if (w < 780) {
        var $menu_overlay = $(this).parent().find('.megamenu_overlay');
        $('.megamenu_overlay').not($menu_overlay).removeClass('open');
        $menu_overlay.toggleClass('open');
        return false;
    }
});

// Tabbed Content Dropdown
$('.tabContainer').on('click', function () {
    var w = $(window).width();
    if (w < 780) {
        $(this).find('h4').toggleClass('open');
        $(this).find('.tabContent').slideToggle('fast');
    }
});


// Close alert.
function removeAlertNotice() {
    $('.js-notice').addClass('is-not-visible');
}

function showAlertNotice() {
    $('.js-notice').removeClass('is-not-visible');
}

function setAlertCookie() {
    var cnTime = new Date(),
        cnLater = new Date(),
        cnValue = true;
    cnLater.setTime(parseInt(cnTime.getTime()) + parseInt(86400) * 1000); // One day.
    document.cookie = 'notice_accepted=' + cnValue + ';expires=' + cnLater.toUTCString() + ';path=/;';
}

if (document.cookie.indexOf('notice_accepted') === -1) {
    showAlertNotice();
} else {
    removeAlertNotice();
}

$('.js-notice-close').on('click', function () {
    setAlertCookie();
    removeAlertNotice();
});

// Show announcement.
function showAnnouncement() {
    if ($('#modal-announcement').length) {
        $('#modal-announcement').modal('show');
    }
}

function setAnnouncementCookie() {
    var cnTime = new Date(),
        cnLater = new Date(),
        cnValue = true;
    cnLater.setTime(parseInt(cnTime.getTime()) + parseInt(3600) * 1000); // One day.
    document.cookie = 'main_announcement_seen=' + cnValue + ';expires=' + cnLater.toUTCString() + ';path=/;';
}

if (document.cookie.indexOf('main_announcement_seen') === -1) {
    showAnnouncement();
}

$('.js-modal-announcement .close, .js-modal-announcement a').on('click', function () {
    setAnnouncementCookie();
});

// Event listener helper.
function addEvent(obj, evt, fn) {
    if (obj.addEventListener) {
        obj.addEventListener(evt, fn, false);
    } else if (obj.attachEvent) {
        obj.attachEvent("on" + evt, fn);
    }
}

// Exit Intent
function showExitIntent() {
    if ($('#modal-exit-intent').length) {
        $('#modal-exit-intent').modal('show');
    }
}

addEvent(document, 'mouseout', function(evt) {
    if (evt.toElement == null && evt.relatedTarget == null) {
        if (document.cookie.indexOf('exit_intent_seen') === -1) {
            showExitIntent();
        }
    }
});

function setExitIntentCookie() {
    var cnTime = new Date(),
        cnLater = new Date(),
        cnValue = true;
    cnLater.setTime(parseInt(cnTime.getTime()) + parseInt(86400) * 1000); // One day.
    document.cookie = 'exit_intent_seen=' + cnValue + ';expires=' + cnLater.toUTCString() + ';path=/;';
}

$('.js-modal-exit-intent .close').on('click', function () {
    setExitIntentCookie();
});

// Scroll to top.
$('.js-scroll-top').on('click', function () {
    $('html, body').animate({
        scrollTop: 0
    });
    return false;
});

// Show scroll to top button based on scroll height.
$(window).scroll(function() {
    var scrollHeight = $(window).scrollTop();
    var $scrollTopButton = $('.js-scroll-top');
    if (scrollHeight >= 150) {
        $scrollTopButton.addClass('active');
    } else {
        $scrollTopButton.removeClass('active');
    }
});

// Add `active` classname to opened mega menu item.
$('.menu-item.megamenu a').on('click', function () {
    $('.menu-item.megamenu').not($(this).parent()).removeClass('active');
    $(this).parent().toggleClass('active');
});

// Append custom archive element.
$('.megamenu_overlay_praxis').parent().append('<div class="megamenu_archive megamenu_archive_praxis">Alles zur Praxis</div>');
$('.megamenu_overlay_leistungen').parent().append('<div class="megamenu_archive megamenu_archive_leistungen">Alle Leistungen</div>');
$('.megamenu_overlay_kontakt').parent().append('<div class="megamenu_archive megamenu_archive_kontakt">Mehr zu Kontakt</div>');

// Make custom archive element clickable.
$('.megamenu_archive').on('click', function () {
    var href = $(this).parent().find('a').attr('href');
    window.open(href,'_self');
});

// Load YouTube Iframe API.
var tag = document.createElement('script');
tag.src = "https://www.youtube.com/iframe_api";
var firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

// Load YouTube background video.
function onYouTubeIframeAPIReady() {
    var player;
    var video_playing = false;
    var video_id = $('.video-background').attr('data-youtube');
    player = new YT.Player('YouTubeBackgroundVideoPlayer', {
        videoId: video_id,
        host: 'https://www.youtube-nocookie.com',
        playerVars: {
            playlist      : video_id,
            autoplay      : 1, // Auto-play the video on load.
            autohide      : 1, // Deprecated for the HTML5 player.
            modestbranding: 1, // Do not display the YouTube logo in the control bar.
            rel           : 0, // Do not show related videos at the end.
            showinfo      : 0, // Do not display information like the video title before the video starts playing.
            controls      : 0, // Hide pause/play buttons in player.
            fs            : 0, // Hide the full screen button.
            disablekb     : 1, // Disable keyboard controls.
            enablejsapi   : 1, // Disable JS API.
            iv_load_policy: 3, // Do not show video annotations.
            loop          : 1 // Loop video only supported with Version 3 of YouTube API.
        },
        events: {
            onReady: function(e) {
                e.target.mute();
                e.target.setPlaybackQuality('hd720'); // Render with better quality: 'hd1080'
            },
            onStateChange: function (e) {
                if (e && e.data === 1) {
                    var videoHolder = document.getElementById('homerBannerVideoWrapper');
                    if (videoHolder && videoHolder.id) {
                        videoHolder.classList.remove('loading');
                    }
                } else if (e && e.data === 0) {
                    e.target.playVideo();
                }
                if (e.data === YT.PlayerState.PLAYING) {
                    video_playing = true;
                    $('.js-toggle-video .button-text').text('Video pausieren');
                } else if (e.data === YT.PlayerState.PAUSED) {
                    video_playing = false;
                    $('.js-toggle-video .button-text').text('Video abspielen');
                }
            }
        }
    });

    $('.skip-to-content').on('click', function () {
        $('html, body').animate({
            scrollTop: $('#overviewWrapper').offset().top - 120
        }, 550);
        return false;
    });

    $('.js-stop-video').on('click', function () {
        if (video_playing) {
            player.pauseVideo();
        }
    });

    $('.js-toggle-video').on('click', function () {
        if (video_playing) {
            player.pauseVideo();
        } else {
            player.playVideo()
        }
    });

    $('.js-toggle-dropdown').on('click', function () {
        $(this).find('.fas').toggleClass('fa-chevron-down').toggleClass('fa-chevron-up');
        $(this).parent().toggleClass('is-open');
    });

    jQuery(window).on('load resize', function () {
        var w = jQuery(window).width();
        if (jQuery(window).width() >= 768) {
            jQuery('.image-background').height(w / 24 * 9);
        } else {
            jQuery('.image-background').height(w / 16 * 9);
        }
    });
}

var w = jQuery(window).width();
if (jQuery(window).width() >= 768) {
    jQuery('.image-background').height(w / 24 * 9);
} else {
    jQuery('.image-background').height(w / 16 * 9);
}
